/**
 * Auth constants shared by server and client.
 */

/** Error code on 401s that mean "no valid session"; the client redirects to login on it. */
export const AUTH_REQUIRED = 'AUTH_REQUIRED';
